<template>
    <div class="signature" :style="'height:' + height">
        <div class="menu-signature">
            <span @click="clear" class="btn btn-primary  btn-sm" title="Clear">
                Clear
            </span>
            <span @click="undo" class="btn btn-warning btn-sm" title="Undo">
                Undo
            </span>
            <span @click="save" class="btn btn-success  btn-sm" title="Save">
                Save
            </span>
        </div>
        <vue-signature :ref="name" :sigOption="option" :disabled="disabled"></vue-signature>
        <input type="hidden" :name="name" v-model="image">
    </div>
</template>

<script>
import vueSignature from "vue-signature"

export default {
    name: "MSignature",
    props: {
        name: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: '100%'
        },
    },
    components: {
        vueSignature
    },
    data() {
        return {
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)"
            },
            disabled: false,
            image: null,
        }
    },
    methods: {
        clear() {
            var _this = this;
            _this.$refs[this.name].clear();
        },
        undo() {
            var _this = this;
            _this.$refs[this.name].undo();
        },
        save() {
            var _this = this;
            var png = _this.$refs[this.name].save()
            this.image = png;
        },
    },
    mounted() {
        if (this.value) {
            var _this = this;
            setTimeout(function () {
                _this.$refs[_this.name].fromDataURL(_this.value);
                _this.image = _this.value
            }, 2000)

        }
    }
}
</script>

<style scoped>
.signature {
    border: 1px solid;
}

.menu-signature {
    position: absolute;
    right: 10px;
    top: -10px;
}
</style>
